






































































































































































































































import { Vue, Component } from "vue-property-decorator";
import FlightPolicyService from "@/service/flightPolicyService";
import productDetails from "../modules/productDetails.vue";
import { DurationTime } from "@/utils/utils.ts";
import { ServiceType, VoyageType, ApplyArea, YesOrNo, Cabin } from "../../../model/Base";
import dataShare from "../dataShare";
import * as _ from "lodash";
import flightPolicyService from "@/service/flightPolicyService";
import { Popup, Overlay, Dialog } from "vant";
import { isOfw } from "@/utils/utils";
import SystemService from "@/service/UserService";

@Component({
  name: "flightInfo",
  components: {
    "product-details": productDetails,
    [Popup.name]: Popup,
    [Overlay.name]: Overlay,
  },
  filters: {
    DurationTime,
  },
})
export default class extends Vue {
  //data
  goods = [] as any[];
  isShowRule: boolean = false;
  dataShare = dataShare;
  showeBookNotic = false;
  get isOfwApp() {
    return isOfw();
  }

  get product(): object {
    return this.$route.query;
  }
  get ProductsList(): any[] {
    if (!this.$route.query?.Products) return [];
    return JSON.parse((this.$route.query.Products as string) || "") || [];
  }
  get ProductID() {
    return this.$route.query.ProductID;
  }
  get Extras() {
    return this.$route.query.Extras;
  }
  get Food() {
    return this.$route.query.Food;
  }
  get ApplyArea() {
    return this.$route.query.ApplyArea + "";
  }
  get isDisabledReserve() {
    return !this.$route.query.approvalCode && this.disabledReserve && (this.$route.query.VoyageType == "1161" || this.$route.query.VoyageType== "1162" && this.$route.query.Selected);
  }
  get Airplane() {
    let airplane = this.$route.query.Airplane;
    if (airplane) {
      if (airplane[0] == "7") {
        return `${this.$root.$t("mall_flight_flightdetails_boyin")}${airplane}`;
      } else if (airplane[0] == "3") {
        return `${this.$root.$t("mall_flight_flightdetails_kongke")}${airplane}`;
      } else if (airplane == "919") {
        return `C${airplane}`;
      }
    }
    return "";
  }
  get ShareFlight() {
    return this.$route.query.ShareFlight;
  }
  get isProductDisable() {
    return this.$route.query.isProductDisable == "Y";
  }
  //mounted
  mounted() {
    this.getGoodsData();
    this.getApprovalExtra();
  }
  //activated
  activated() {
    this.showeBookNotic = false;
    this.berthDetail = {};
  }
  decorateChannelName(good: any) {
    let PackagePrice = null;
    var extra = _.find(good.Extras, p => p.ExtraCode == "flight.VoyageType");
    if (extra) {
      return "旅行套餐";
    }
    return this.$root.$t("mall_flight_flightdetails_shangwutuijian");
  }

  // 判断是否为国际往返程的返程
  get isInternationalRoundTripReturn(): boolean {
    const query = this.$route.query;
    return String(query.ApplyArea) === "1127" && String(query.VoyageType) === "1162" && !!query.Selected;
  }

  getGoodsData() {
    let product = this.$route.query as any;
    if(product.isTransfer=='Y'){
        const goodsList = this.dataShare.transferSearchGoods || [];
        let conformGoods = this.dataShare.conformGoods || [];
        _.remove(conformGoods, (o: any) => o.SourceID == goodsList[0]?.SourceId);
        goodsList.forEach((goods: any) => {
          if (this.matchLocalContrarys(goods) == null) {
            conformGoods.push({ SourceID: goods.SourceId, GoodsID: goods.GoodsId });
          }
        });
        this.dataShare.conformGoods = conformGoods;
        this.goods = goodsList;
        return;
    }
    let queryConsumers = JSON.parse(product.Consumers) || [];

    let consumerIDs = queryConsumers.map((o: any) => o.ConsumerID);

    const data = {
      ProductId: product.ProductId,
      ApplyArea: product.ApplyArea,
      BookingType: product.BookingType,
      Consumers: consumerIDs,
      VoyageType: product.VoyageType,
      ShoppingID: product.ShoppingID,
      LevelId: product.BerthLevel,
      SelectId: [product.SelectId],
      GoodsId: product.GoodsId,
    };
    FlightPolicyService.getProductGoods(data).then(res => {
      if (res.isSucc && res.result && res.result.length > 0) {
        let conformGoods = this.dataShare.conformGoods || [];
        _.remove(conformGoods, (o: any) => o.SourceID == res.result[0].SourceId);
        res.result.forEach((goods: any) => {
          // 只有在国际往返程去程且没有MultiFlights时组合价格
          // if (this.isInternationalRoundTripReturn && product.HasMultiFlights === "false") {
          //   const basisPrice = parseFloat(product.BasisPrice as string) || 0;
          //   goods.BasisPrice += basisPrice;
          // }

          if (this.matchLocalContrarys(goods) == null) {
            conformGoods.push({ SourceID: goods.SourceId, GoodsID: goods.GoodsId });
          }
        });
        this.dataShare.conformGoods = conformGoods;
        this.goods = res.result;
      } else {
        Dialog.alert({
          title: "温馨提示",
          message: "当前航班没有可选舱位，请选择其他航班",
          confirmButtonText: "我知道了",
        }).then(() => {});
      }
    });
  }
  calcDiscountText(detail: any) {
    if (!detail.Discount) {
      return "";
    }
    let discount = detail.Discount * 10;
    if (discount >= 10) {
      return "";
    }
    return `${this.$root.$t("mall_flight_flightdetails_zhe", [discount.toFixed(1)])}`;
  }
  matchLocalContrarys(goods: any) {
    let localContrarys = this.dataShare.localContrarys;
    if (localContrarys && localContrarys.length > 0) {
      let contrary = _.find(localContrarys, o => o.SourceID == goods.SourceId);
      if (contrary == null || contrary.SuggestBasisPrice >= goods.BasisPrice) {
        return null;
      }
      return contrary.ContraryInfo;
    }
    return null;
  }
  isContrary(goods: any) {
    if (this.matchLocalContrarys(goods) !== null) {
      return true;
    }
    return goods && goods.Contrarys && goods.Contrarys.length > 0;
  }
  contraryTips(goods: any) {
    let contrarys: string[] = [];
    if (goods && goods.Contrarys) {
      [].push.apply(contrarys, goods.Contrarys);
    }
    let message = this.matchLocalContrarys(goods);
    if (message !== null) {
      contrarys.push(message);
    }

    return _.uniq(contrarys).join(",");
  }
  showContraryTips(goods: any) {
    this.$root.$toast((this.$root.$t("mall_flight_flightdetails_weibei") as string) + this.contraryTips(goods));
  }

  cacheRules: any = {};
  activeRule: any = {};
  showRuleInfo(goods: any) {
    let __self = this;
    let ProductId = `${goods.SourceId}-${goods.ProductId}-${goods.GoodsId}-${goods.GoodSource}`;
    let query = __self.$route.query;
    let activeRule = this.cacheRules[ProductId];
    if (activeRule) {
      __self.activeRule = activeRule;
      __self.isShowRule = true;
      return;
    }
    flightPolicyService.SearchAmendPolicy(ProductId, query.ApplyArea).then(o => {
      let bagObjs = this.matchBaggage(goods) as any[];
      let carryonBag = bagObjs.find(o => o.BaggageCode == "1975");
      let consignBag = bagObjs.find(o => o.BaggageCode == "1976");
      let bagRules = [];
      if (carryonBag == null) {
        bagRules.push((this.$t("mall_flight_flightdetails_yihangsizuixinguidingweizhun") as string));
      } else if (carryonBag.Weight == 0 || (!carryonBag.Weight && !carryonBag.RuleDesc) || (!carryonBag.Weight && carryonBag.RuleDesc && carryonBag.RuleDesc.indexOf("无") >= 0)) {
        bagRules.push("无手提行李额");
      } else if (carryonBag.Weight) {
        let cubage = carryonBag.Width && carryonBag.height && carryonBag.Depth ? `体积不超过${carryonBag.Width}x${carryonBag.Height}x${carryonBag.Depth}CM;` : "";
        bagRules.push(`免费手提行李1件${carryonBag.Weight}${carryonBag.UnitCode};${cubage}`);
      } else {
        bagRules.push(`免费手提行李${carryonBag.RuleDesc}`);
      }
      if (consignBag == null) {
        bagRules.push((this.$t("mall_flight_flightdetails_yihangsizuixinguidingweizhun") as string));
      } else if (consignBag.Weight == 0 || (!consignBag.Weight && !consignBag.RuleDesc) || (!consignBag.Weight && consignBag.RuleDesc && consignBag.RuleDesc.indexOf("无") >= 0)) {
        bagRules.push("无托运行李额");
      } else if (consignBag.Weight) {
        let cubage = consignBag.Width && consignBag.height && consignBag.Depth ? `单件体积不超过${consignBag.Width}x${consignBag.Height}x${consignBag.Depth}CM;` : "";
        bagRules.push(`免费托运行李${consignBag.Weight}${consignBag.UnitCode};${cubage}`);
      } else {
        bagRules.push(`免费托运行李${consignBag.RuleDesc}`);
      }

      if (o.isSucc && o.result != "") {
        __self.cacheRules[ProductId] = o.result;
        if (!o.result) {
          o.result = {};
        }
        if (!o.result.BagRules) {
          o.result.BagRules = bagRules;
        }
        __self.activeRule = o.result;
      } else {
        __self.activeRule = { BagRules: bagRules };
      }
      __self.isShowRule = true;
    });
  }

  get IsDevelop() {
    let featureCodes = this.profile.FeatureCodes || [];
    let result = _.find(featureCodes, o => o == "system.develop");
    if (result) {
      return true;
    }
    return false;
  }

  get MustConform() {
    return this.$route.query.MustConform || YesOrNo.No;
  }
  get FeatureCodes() {
    return this.$route.query.FeatureCodes || "";
  }

  matchQunarInvoice(good: any) {
    // Qunar.InvoiceAndItinerary //行程单+差额发票
    // Qunar.Itinerary //全额行程单
    let qunarInvoice = _.find(good.Extras, item => item.ExtraCode == "Qunar.InvoiceAndItinerary" || item.ExtraCode == "Qunar.Itinerary");
    if (!qunarInvoice) return undefined;
    if (qunarInvoice.ExtraCode == "Qunar.InvoiceAndItinerary") {
      return "行程单+差额发票";
    } else if (qunarInvoice.ExtraCode == "Qunar.Itinerary") {
      return "提供行程单";
    }
    return undefined;
  }

  matchBaggage(good: any) {
    let baggage = _.find(good.Extras, item => item.ExtraCode == "flight.baggages");
    if (baggage) {
      let bagObjs = JSON.parse(baggage.ExtraData);
      return bagObjs || [];
    }
    return [];
  }
  matchConsignBaggage(good: any) {
    let bagObjs = this.matchBaggage(good);
    if (bagObjs && bagObjs.length > 0) {
      let bagObj = bagObjs.filter((bag: any) => bag.BaggageCode == "1976")[0];
      if (!bagObj) {
        return false;
      }
      if (!bagObj.Weight) {
        if (!bagObj.RuleDesc || bagObj.RuleDesc.indexOf("无") >= 0) {
          return null;
        }
      }
      if (bagObj.Weight) {
        return `免费托运行李${bagObj.Weight}${bagObj.UnitCode}`;
      }
      return `托运行李额${bagObj.RuleDesc}`;
    }
    return false;
  }
  isboundInsurance(good: any) {
    let insurance = _.find(good.Extras, item => item.ExtraCode == "insurance.package.salesprice");
    if (insurance) {
      return parseInt(insurance.ExtraData);
    }
  }

  isDisabled(good: any) {
    let __self = this;
    let el = _.find(good.Extras, item => item.ExtraCode == "good.B2GPolicy" && item.ExtraData == "FALSE");
    if (el) {
      return true;
    }
    if (!(good.Contrarys && good.Contrarys.length > 0)) {
      return false;
    }
    if (this.FeatureCodes.indexOf("ForbidViolate") !== -1) {
      return true;
    }
    return (__self.MustConform && __self.MustConform == (YesOrNo.Yes as any)) || (this.isHideOverproof && (!this.isPermitViolate || good.GoodsLevel != Cabin.Economy));
  }

  get isPermitViolate() {
    return this.FeatureCodes.indexOf("PermitViolate") > -1;
  }
  get isHideOverproof() {
    return this.FeatureCodes.indexOf("HideProduct") > -1;
  }

  isShowGood(good: any, index: number) {
    //差旅政策规定 隐藏违背政策的产品 违背政策的商品 且 不是第一条
    if (this.isHideOverproof && good.Contrarys.length > 0 && index > 0) {
      return false;
    }
    return true;
  }

  canAmendRenew(detail: any) {
    return detail.Prices && detail.Prices.length > 0 && detail.Prices[0].FeatureCode == "Amend";
  }

  GoodsNumber(count: string) {
    let Flag = false;
    if (/^[0-9]$/.test(count) && count.length == 1) {
      Flag = true;
    }
    return Flag;
  }
  berthDetail:any = {}
  gotoOrder(detail: any, skipTwoHourTip: boolean = false): void {
    const query = this.$route.query as any;
    this.berthDetail = detail;
    if (this.isDisabled(detail)) {
      let el = _.find(detail.Extras, item => item.ExtraCode == "good.B2GPolicy" && item.ExtraData == "FALSE");
      let message = this.$root.$t("mall_flight_flightdetails_gaihangbanweiyinbeiguizebukeyuding") as string;
      if (el) {
        message = this.$root.$t("mall_flight_flightdetails_nsyddxyjgxytqbàcngsy") as string;
      }
      this.$root.$toast(message);
      return;
    }
    if (!skipTwoHourTip && this.isFirstDepartWithinTwoHours(query)) {
      Dialog.confirm({
        title: "温馨提示",
        message: "您选择的是距起飞2小时内的航班，误机风险高，值机/改退可能受限，请确认是否继续预订。",
        confirmButtonText: "继续预订",
        cancelButtonText: "取消预定",
        closeOnPopstate: true,
        width:'90%'
      })
        .then(() => {
          this.gotoOrder(detail, true);
        })
        .catch(() => {});
      return;
    }
    if (this.isInternationalRoundTripReturn && query.HasMultiFlights === "false") {
      // 开启弹窗
      this.showeBookNotic = true;
      return;
    }
    let ProductID = `${query.SourceId}-${query.ProductId}-${detail.GoodsId}-${detail.GoodSource}`;
    // 如果存在 ExtraCode 为 SelectFirstGoodId 的情况，则替换去程的 GoodsId
    if (this.ProductID) {
      const selectFirstGoodIdExtra: any = _.find(detail.Extras, (item: any) => item.ExtraCode === "SelectFirstGoodId");
      if (selectFirstGoodIdExtra && query.ApplyArea == "1127" && query.VoyageType == "1162") {
        const productIdStr = Array.isArray(this.ProductID) ? this.ProductID[0] : this.ProductID;
        const parts = (productIdStr || "").split("-");
        // 将其替换为当前的 detail.GoodsId
        parts[3] = selectFirstGoodIdExtra.ExtraData;
        ProductID = `${parts.join("-")},${ProductID}`;
      } else {
        ProductID = `${this.ProductID},${ProductID}`;
      }
    }
    // 如果是中转 替换拼接
    if (query.isTransfer == 'Y') {
      let fileNames:string[] = [];
      let productIds = query.ProductId.split(",");
      let goodsIds = detail.GoodsId.split(",");
      
      this.ProductsList.forEach((product, index) => {
        let productId = productIds[index] || "";
        let goodsId = goodsIds[index] || "";
        let fileName = `${product.SourceId || ""}-${productId}-${goodsId}-${detail.GoodSource}`;
        fileNames.push(fileName);
      });
      ProductID = fileNames.join(",");
    }
    let ChangeProductID = "";
    if (query.UniqueID) {
      const OldProducts = dataShare.changeSource;
      _.forEach(OldProducts, (item: any) => {
        if (item.ConsumerCityName == query.ConsumerCityName) {
          ChangeProductID = `${query.SourceId}-${query.ProductId}-${detail.GoodsId}-${detail.GoodSource}-${item.ProductID}`;
        }
      });
    }
    if (query.ChangeProductID) {
      ChangeProductID = `${query.ChangeProductID},${ChangeProductID}`;
    }
    if (query.VoyageType == VoyageType.RoundVoyage) {
      if (!query.Selected) {
        let PackagePrice = null;
        var extra = _.find(detail.Extras, (p: any) => p.ExtraCode == "flight.VoyageType");
        if (extra) {
          PackagePrice = "true";
        }
        let product = this.product as any;

        let router = {
          path: "/mall/flight/list",
          query: {
            ...query,
            Selected: ProductID,
            SelectId: query.ProductId,
            BookingType: query.BookingType,
            VoyageType: query.VoyageType,
            ApplyArea: query.ApplyArea,
            UniqueID: query.UniqueID,
            ShoppingID: query.ShoppingID,
            ServiceType: ServiceType.FlightService + "",
            Consumers: query.Consumers,
            DepartDate: query.ArriveDate,
            DepartCity: query.ArriveCity,
            ArriveCity: query.DepartCity,
            DepartCode: query.ArriveCode,
            ArriveCode: query.DepartCode,
            DepartCityName: query.ArriveCityName,
            ArriveCityName: query.DepartCityName,
            RuleID: query.RuleID,
            FlowID: query.FlowID,
            RuleType: query.RuleType,
            ChangeProductID: ChangeProductID,
            Product: query.Product,

            GoFlightCode: product.ProduceCode,
            GoFlightNo: product.BatchCode,
            GoBerthCode: detail.GoodsCode,
            GoPackagePrice: PackagePrice,
            GoFlightDate: query.DepartDate,
            GoGoodsId: detail.GoodsId,
            approvalCode:query.approvalCode
          },
        };
        this.$router.push(router);
        return;
      }
    }
    if (query.RuleType == "Change") {
      query.Selected = ChangeProductID;
      this.$router.push({
        path: "/mall/flight/ChangeInfos",
        query: query,
      });
      return;
    }
    this.$router.push({
      path: "/mall/flight/order",
      query: {
        ...query,
        //业务参数
        ProductId: ProductID,
        BookingType: query.BookingType,
        VoyageType: query.VoyageType,
        ApplyArea: query.ApplyArea,
        UniqueID: query.UniqueID,
        ShoppingID: query.ShoppingID,
        ServiceType: ServiceType.FlightService + "",
        Consumers: query.Consumers,
        //附加参数
        RuleID: query.RuleID,
        FlowID: query.FlowID,
        ArriveCityName: query.ArriveCityName,
        DepartCityName: query.DepartCityName,
        Extras: query.Extras,
        stopTime: query.stopTime,
        approvalCode:query.approvalCode
      },
    });
  }
  isFirstDepartWithinTwoHours(query: any): boolean {
    let firstDepartTime = "";
    if (this.ProductsList && this.ProductsList.length > 0) {
      firstDepartTime = this.ProductsList[0].ConsumerDate || "";
    } else {
      firstDepartTime = query.ConsumerDate || "";
    }
    const firstDepartTimestamp = firstDepartTime ? new Date(firstDepartTime).getTime() : 0;
    if (!firstDepartTimestamp) {
      return false;
    }
    const twoHours = 2 * 60 * 60 * 1000;
    const diffTime = firstDepartTimestamp - Date.now();
    return diffTime > 0 && diffTime <= twoHours;
  }
  noticeBooking(skipTwoHourTip: boolean = false): void {
    this.showeBookNotic = false;
    const query = this.$route.query as any;
    if (!skipTwoHourTip && this.isFirstDepartWithinTwoHours(query)) {
      Dialog.confirm({
        title: "温馨提示",
        message: "您选择的是距起飞2小时内的航班，误机风险高，值机/改退可能受限，请确认是否继续预订。",
        confirmButtonText: "继续预订",
        cancelButtonText: "取消预定",
        closeOnPopstate: true,
        width:'90%'
      })
        .then(() => {
          this.noticeBooking(true);
        })
        .catch(() => {});
      return;
    }
    const detail = this.berthDetail as any;
    let ProductID = `${query.SourceId}-${query.ProductId}-${detail.GoodsId}-${detail.GoodSource}`;
    // 如果存在 ExtraCode 为 SelectFirstGoodId 的情况，则替换去程的 GoodsId
    if (this.ProductID) {
      const selectFirstGoodIdExtra: any = _.find(detail.Extras, (item: any) => item.ExtraCode === "SelectFirstGoodId");
      if (selectFirstGoodIdExtra && query.ApplyArea == "1127" && query.VoyageType == "1162") {
        const productIdStr = Array.isArray(this.ProductID) ? this.ProductID[0] : this.ProductID;
        const parts = (productIdStr || "").split("-");
        // 将其替换为当前的 detail.GoodsId
        parts[3] = selectFirstGoodIdExtra.ExtraData;
        ProductID = `${parts.join("-")},${ProductID}`;
      } else {
        ProductID = `${this.ProductID},${ProductID}`;
      }
    }
    // 如果是中转 替换拼接
    if (query.isTransfer == 'Y') {
      let fileNames:string[] = [];
      let productIds = query.ProductId.split(",");
      let goodsIds = detail.GoodsId.split(",");
      
      this.ProductsList.forEach((product, index) => {
        let productId = productIds[index] || "";
        let goodsId = goodsIds[index] || "";
        let fileName = `${product.SourceId || ""}-${productId}-${goodsId}-${detail.GoodSource}`;
        fileNames.push(fileName);
      });
      ProductID = fileNames.join(",");
    }
    let ChangeProductID = "";
    if (query.UniqueID) {
      const OldProducts = dataShare.changeSource;
      _.forEach(OldProducts, (item: any) => {
        if (item.ConsumerCityName == query.ConsumerCityName) {
          ChangeProductID = `${query.SourceId}-${query.ProductId}-${detail.GoodsId}-${detail.GoodSource}-${item.ProductID}`;
        }
      });
    }
    if (query.ChangeProductID) {
      ChangeProductID = `${query.ChangeProductID},${ChangeProductID}`;
    }
    if (query.RuleType == "Change") {
      query.Selected = ChangeProductID;
      this.$router.push({
        path: "/mall/flight/ChangeInfos",
        query: query,
      });
      return;
    }
    this.$router.push({
      path: "/mall/flight/order",
      query: {
        ...query,
        //业务参数
        ProductId: ProductID,
        BookingType: query.BookingType,
        VoyageType: query.VoyageType,
        ApplyArea: query.ApplyArea,
        UniqueID: query.UniqueID,
        ShoppingID: query.ShoppingID,
        ServiceType: ServiceType.FlightService + "",
        Consumers: query.Consumers,
        //附加参数
        RuleID: query.RuleID,
        FlowID: query.FlowID,
        ArriveCityName: query.ArriveCityName,
        DepartCityName: query.DepartCityName,
        Extras: query.Extras,
        stopTime: query.stopTime,
        approvalCode:query.approvalCode
      },
    });
  }
  calculateTimeDifference(startTime: string, endTime: string) {
    const startDate: number = (new Date(startTime) as unknown) as number;
    const endDate: number = (new Date(endTime) as unknown) as number;
    // 计算时间差，单位为秒
    let diffInSeconds = (endDate - startDate) / 1000;
    // 计算天数
    const days = Math.floor(diffInSeconds / (24 * 3600));
    // 剩余的小时数
    const hours = Math.floor((diffInSeconds % (24 * 3600)) / 3600);
    // 剩余的分钟数
    const minutes = Math.floor((diffInSeconds % 3600) / 60);
    // 构建返回结果
    let result = "";
    if (days > 0) result += `${days}d`;
    if (hours > 0) result += `${hours < 10 ? "0" + hours : hours}h`;
    if (minutes > 0) result += `${minutes < 10 ? "0" + minutes : minutes}m`;
    return result;
  }
  AirplaneModel(list: any) {
    let AirplaneModel = "";
    let result = _.find(list.Extras, o => {
      return o.ExtraCode == "flight.AirplaneModel";
    });
    if (result) {
      AirplaneModel = result.ExtraData;
    }
    return AirplaneModel;
  }
  foodExtra(Extras: any[]) {
    if (!Extras || Extras.length == 0) return "";
    const Extra = _.find(Extras, item => item.ExtraCode == "flight.FoodName");
    if (Extra) {
      return Extra.ExtraData;
    }
    return "";
  }
  foodReset(Product: any) {
    let __self = this;
    let Extras = [];
    if (__self.ApplyArea == "1126") {
      Extras = Product.Extras;
    } else {
      const products = Product.Products ? JSON.parse(Product.Products) : [];
      Extras = products?.[0]?.Extras ?? [];
    }
    if (!Extras || Extras.length == 0) return "";
    const Extra = _.find(Extras, item => item.ExtraCode == "flight.FoodName");
    if (Extra) {
      return Extra.ExtraData;
    }
    return "";
  }
  disabledReserve:boolean = false;
  getApprovalExtra(){
    let __self=this;
    let data={
      ExtraCode:'company.ApprovalInfoSetting',
      MasterID:__self.profile.CompanyID || ''
    };
    SystemService.getCompanyExtra(data).then(p=>{
      if(p.isSucc){
        const data=p.result;
        if(data && data.ExtraData){
          __self.disabledReserve=data.ExtraData.indexOf('selectApprovalBooking')>-1 || false;
        }
      }
    })
  }
  showHint(type:string){
    let message = type === 'isDisabledReserve' ? '请选择审批单进行预定！' : '中转换乘时间较短！';
    Dialog.alert({
      title: "温馨提示",
      message,
      confirmButtonText: "我已知晓",
    }).then(() => {
    });
  }
}
